import React from "react";
import { Trans } from "react-i18next";

interface TutorialTransStepProps {
    translationKey: string;
    icon?: React.ReactNode;
}

const TutorialTransStep: React.FC<TutorialTransStepProps> = ({ translationKey, icon }) => {
    const components: { [key: string]: React.ReactElement } = {
        strong: <strong />,
    };

    if (icon) {
        components.icon = <>{icon}</>;
    }
    return (
        <p className="fs-7 mb-0">
            <Trans i18nKey={`tutorial.${translationKey}`} components={components} />
        </p>
    );
};

export default TutorialTransStep;
